import { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import CarouselButton from 'components/atoms/CarouselButton';

interface ArrowsProps extends IDefaultArrowsProps {
  prev?: () => void;
  next?: () => void;
}

export interface IDefaultArrowsProps {
  currentSlide: number;
  totalSlides: Array<number>;
  onClickIndicator?: (slide: number) => void;
}

const SliderArrow: FC<ArrowsProps> = ({ totalSlides, currentSlide, onClickIndicator, prev, next }) => {
  const nextFunc = () => {
    if (currentSlide >= totalSlides.length - 1) {
      onClickIndicator(0);
    } else {
      onClickIndicator(currentSlide + 1);
    }
  };

  const prevFunc = () => {
    if (currentSlide < 1) {
      onClickIndicator(totalSlides.length - 1);
    } else {
      onClickIndicator(currentSlide - 1);
    }
  };

  return (
    <Grid container direction="row" justify="center" spacing={5}>
      <Grid item>
        <CarouselButton text="Prev" onClick={prev ? prev : prevFunc} aria-label="Prev" isPrev>
          <Typography>Prev</Typography>
        </CarouselButton>
      </Grid>
      <Grid item>
        <CarouselButton text="Next" onClick={next ? next : nextFunc} aria-label="Next">
          <Typography>Next</Typography>
        </CarouselButton>
      </Grid>
    </Grid>
  );
};
export default SliderArrow;
